import 'css-chunksrc/client/pages/projectPage/budgetPage/costsBreakdownByResourceType/styles.scss';export default {
  "costsBreakdownByResourceType": "_costsBreakdownByResourceType_1k1ly_1",
  "title": "_title_1k1ly_8",
  "graph": "_graph_1k1ly_15",
  "col": "_col_1k1ly_21",
  "row": "_row_1k1ly_36",
  "legend": "_legend_1k1ly_44",
  "name": "_name_1k1ly_50",
  "cost": "_cost_1k1ly_1"
};